const fileKey = (file) => file?.id || file?.fileGCSKey || "";

export const cleanupCancelledPaymentPlatformUpload = async ({
  tenantId,
  files = [],
  deleteCatalogFile,
  deleteStorageFile,
}) => {
  const uniqueFiles = [...new Map(files.filter(fileKey).map((file) => [fileKey(file), file])).values()];
  const results = await Promise.allSettled(uniqueFiles.map((file) => (
    file.id
      ? deleteCatalogFile(tenantId, file.id)
      : deleteStorageFile(tenantId, file.fileGCSKey)
  )));
  const failed = uniqueFiles.filter((file, index) => {
    const result = results[index];
    if (result.status === "fulfilled") return false;
    return result.reason?.response?.status !== 404;
  });
  return { deleted: uniqueFiles.length - failed.length, failed };
};

